import { render, staticRenderFns } from "./EditBrigade.vue?vue&type=template&id=657d259b&scoped=true&"
import script from "./EditBrigade.vue?vue&type=script&lang=js&"
export * from "./EditBrigade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657d259b",
  null
  
)

export default component.exports
import {QCard,QCardSection,QToolbar,QToolbarTitle,QTabs,QTab,QTooltip,QBadge,QIcon,QItem,QInput,QSelect,QItemSection,QList,QItemLabel,QInnerLoading,QSpinnerGears,QSeparator,QCardActions,QBtn,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QToolbar,QToolbarTitle,QTabs,QTab,QTooltip,QBadge,QIcon,QItem,QInput,QSelect,QItemSection,QList,QItemLabel,QInnerLoading,QSpinnerGears,QSeparator,QCardActions,QBtn}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
